/**
 * BH Stone Switcher — Navigate to sibling product on swatch click.
 * Simple redirect, no AJAX. Reliable, zero conflicts with theme components.
 */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var ring = e.target.closest('[data-bh-stone-handle]');
    if (!ring) return;

    var handle = ring.getAttribute('data-bh-stone-handle');
    if (!handle) return;

    // Don't navigate if already on this product
    if (ring.classList.contains('bh-stones__ring--active')) return;

    e.preventDefault();
    window.location.href = '/products/' + handle;
  });
  // Note: the "hint" reveal cascade is pure CSS (class bh-stones--reveal). The class
  // is added by a tiny inline script in product-info.liquid, gated on a sessionStorage
  // flag so the cascade plays once per session (first PDP open) and does NOT replay on
  // every sibling-stone navigation. The active stone is included in the cascade.
})();
